import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Select, MenuItem } from '@material-ui/core';

export default ({ text, setor, handleInputChange }) => {
  
  const useStyles = makeStyles({
    root: {
      '& .Mui-InputBase-root': {
        border: 'none',
        height: 'auto'
      }
    }
  })
  
  const classes = useStyles();

  let options = []

  for (let i = 0; i <= 5; i++) {
    options.push(
      <MenuItem value={ text.getEmailSelect()[i]}>
        { text.getTextoSelect()[i] }
      </MenuItem>
    )
  }

  return (
    <Select
          disableUnderline
          classes={{
            root: classes.root
          }}
          value={ setor }
          className="selectContato"
          onChange={ handleInputChange }
          inputProps={{
            name: 'setor',
            id: 'setor',
          }}
          style={ { overflow: 'hidden', marginTop: '5vh', width: "100%" } }
        >
          <MenuItem value='none' disabled selected={true}>
            <em>{ text.getTextSetor() }</em>
          </MenuItem>

          { options }
    </Select>
  )
}